export interface IPrevRefValues {
  [key: string]: string | boolean;
}

export const onBlurHandler = (
  event: React.FocusEvent<HTMLInputElement | HTMLSelectElement>,
  prevRefValues: React.RefObject<IPrevRefValues>,
) => {
  const name = event.target.name;
  const value = event.target.value;
  const prevValue = prevRefValues.current[name];
  if (value === prevValue || (!prevValue && !value)) {
    prevRefValues.current[name] = value;
    return;
  }

  prevRefValues.current[name] = value;
};
